module.exports = __webpack_public_path__ + "static/media/sb_tip4.dd44c68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/sb_tip4.jpg
// module id = 545
// module chunks = 0